import { callPrivateApi } from '@/api/apiHelper'

// eslint-disable-next-line import/prefer-default-export
export const getWorkshops = async () => callPrivateApi('get', '/workshops')
